import { render } from "./ProductImages.vue?vue&type=template&id=4fbba92a&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"

import "./ProductImages.vue?vue&type=style&index=0&id=4fbba92a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbba92a"]])

export default __exports__